// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import AddressSharedStyles from "@sc/App/SharedStyles/LocationPage/LocationAddressStyles";
import { orderTotalDisplaySharedStyles } from "@sc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartFulfillmentMethodStyles } from "@sc/Overrides/Widgets/Cart/CartFulfillmentMethodSelector";
import ChangeBranch from "@sc/XDL/Icons/ChangeBranch";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

cartFulfillmentMethodStyles.container = {
    ...orderTotalDisplaySharedStyles.wrapper,
};

cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = {
    mergeCss: true,
    labelProps: {
        css: css`
            &&& {
                width: 100%;
                font-size: 16px;
                line-height: 22px;
                padding-bottom: 12px;
                margin-bottom: 0;
                font-weight: bold;
                border-bottom: 1px solid ${color("common.border")};
            }
        `,
    },
    css: css`
        width: 100%;
        ${RadioStyle}:not(:first-child) {
            margin-top: 12px;
        }

        & > ${TypographyStyle} {
            &:empty {
                display: none;
            }
        }

        input[type="radio"] {
            margin-left: 0;
        }
    `,
};

cartFulfillmentMethodStyles.pickUpLocation = {
    wrapper: {
        css: css`
            margin-top: 8px;
        `,
    },
    headerText: {
        weight: fontConfig.weight.bold,
        size: 14,
        lineHeight: "24px",
    },
    changeLink: {
        icon: {
            iconProps: {
                src: ChangeBranch,
            },
            position: "left",
        },
        css: css`
            margin-left: 15px;
            align-items: end;
        `,
    },
    warehouseAddress: {
        address: AddressSharedStyles.address,
        nameText: AddressSharedStyles.warehouseNameText,
    },
};

cartFulfillmentMethodStyles.fulfillmentMethodRadio = {
    mergeCss: true,
    css: css`
        display: inline-flex;
    `,
};
